import React, { Component } from 'react'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group' // ES6

require('./connecting.css')

export default class Connecting extends Component {
  constructor() {
    super()

    this.state = {
      popups: [],
    }
  }

  componentDidMount() {
    this.startPopups()
  }

  componentWillUnmount() {
    clearTimeout(this.addPopupTimeout)
    clearInterval(this.popupTimer)
  }

  render() {
    return (
      <div className="connecting-container">
        <div className="video_contain">
          <video playsInline loop muted autoPlay className="backgroundVideo">
            <source src="/video/connecting.mp4" type="video/mp4" />
          </video>
        </div>

        <ReactCSSTransitionGroup className="popup-container" transitionName="fadeout" transitionLeaveTimeout={0} transitionEnterTimeout={6}>
          {this.state.popups.map(function(popup, index) {
            return <React.Fragment key={index}>{popup}</React.Fragment>
          })}
        </ReactCSSTransitionGroup>
      </div>
    )
  }

  popups() {
    return this.state.popups.map(function(popup, index) {
      return <React.Fragment key={index}>{popup}</React.Fragment>
    })
  }

  startPopups() {
    const popups = [
      {
        title: 'Did you know?',
        text: 'In the early days of Podcasts, #TheCabin had one of the most highly ranked Podcasts available.',
      },
      {
        title: 'Did you know?',
        text: '#TheCabin is using a platform called Internet Relay Chat, or IRC.  IRC has been a part of the internet longer than the World Wide Web has.',
      },
      {
        title: 'Cupid Strikes',
        text: "#TheCabin isn't meant to be a dating site, but multiple people have been married after meeting here!",
      },
      {
        title: 'Did you know?',
        text: 'The person who started Napster at one point hung out in #TheCabin.',
      },
      {
        title: 'Did you know?',
        text: '#TheCabin once had its own radio station called Cabin Radio.',
      },
    ]

    this.popupTimer = setInterval(function() {
      add()
    }, 6000)

    function add() {
      const popupIndex = Math.floor(Math.random() * popups.length)
      const popup = popups[popupIndex]
      if (popup) {
        popups.splice(popupIndex, 1)
        this.addPopup(popup.title, popup.text)
      }
    }

    add = add.bind(this)

    this.addPopupTimeout = setTimeout(function() {
      add()
    }, 1000)
  }

  addPopup(title, text) {
    // make position sensitive to size and document's width
    const windowWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 400) - 400
    const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 400) - 200
    const generatedPosX = (Math.random() * windowWidth).toFixed()
    const posx = Math.min(Math.max(generatedPosX, 20), windowWidth)
    const generatedPosY = (Math.random() * windowHeight).toFixed()
    const posy = Math.min(Math.max(generatedPosY, 20), windowHeight)

    const positionStyle = {
      position: 'absolute',
      left: posx + 'px',
      top: posy + 'px',
    }

    const popup = (
      <div key={title} className="popup expanded fadeout-enter-active" style={positionStyle}>
        <div className="blur" />
        <div className="popup-text">
          <div className="popup-header">{title}</div>
          {text}
        </div>
      </div>
    )

    let popups = this.state.popups
    popups.push(popup)
    this.setState({ popups: popups })
  }
}



// WEBPACK FOOTER //
// ./src/views/connecting/Connecting.jsx